var axios = require('axios')


export function post (url, data, callback, errorCallback) {
  axios.post(url, data, { headers: { 'Content-Type': 'application/json' } })
    .then(callback)
    .catch(errorCallback)
}



export function objectToQuerystring (obj) {
  return Object.keys(obj).reduce(function (str, key, i) {
    var delimiter, val;
    delimiter = (i === 0) ? '?' : '&';

    key = encodeURIComponent(key);
    val = encodeURIComponent(obj[key]);
    
    return [str, delimiter, key, '=', val!='null'?val:''].join('');
  }, '');
}
